export default import.meta.ROLLDOWN_FILE_URL_8ftvE5Y9s6eu6XTIqdB91w